export default __webpack_public_path__ + "static/media/VinitaBhandiwad.8c79c13b.png";